import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from 'components/common/ErrorMessage';
import toast from 'react-hot-toast';
import { Spinner } from 'reactstrap';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import PhoneInput from 'components/common/PhoneInput';
import { setError } from 'slices/facilitiesSlice';
import { fetchFacilitiesList } from 'slices/facilitiesSlice';
import { addFacility } from 'slices/facilitiesSlice';
import { updateFacility } from 'slices/facilitiesSlice';
import { facilitiesSelector } from 'slices/facilitiesSlice';
import { SubmitButton } from 'components/common/buttons/SubmitButton';

const apiService = new Api();
const AddFacilityForm = ({ item, handleClose, callback, show, statusPerm, userId }) => {
  const dispatch = useDispatch()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, } = useForm();
  const { error, loader } = useSelector(facilitiesSelector);
  const [buttonLoader, setButtonLoader] = useState(false)

  useEffect(() => {
    setValue('abbreviation', item?.abbreviation || '')
    setValue('phone', item?.phone || '')
    setValue('address', item?.address || '');
    setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
    dispatch(setError({}))
  }, [item])

  const ResetField = () => {
    setValue('abbreviation', '');
    setValue("phone", '');
    setValue('address', '');
    setValue('status', 1)
  }

  useEffect(() => {
    !show && ResetField();
    return () => ResetField()
  }, [show])
 



  const submitCallback = (status, message) => {
    setButtonLoader(false)
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      handleClose()
      ResetField()
      dispatch(fetchFacilitiesList(1, { location_id: userId }))
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
      setTimeout(() => {
        setButtonLoader(false)
      }, 1000);
    }
  };

  const onSubmit = (data) => {
    setButtonLoader(true)
    const formData = {
      ...data,
      location_id: userId,
    }

    if (item?.id) {
      dispatch(updateFacility(formData, item?.id, submitCallback, true));
    }
    else
      dispatch(addFacility(formData, submitCallback, true));

  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} >
      <div className='theme_form'>
        <div className="row-primary row_secondary">
          <h2>Facility Name *</h2>
          <div className="w-100">
            <Controller
              name="abbreviation"
              control={control}
              rules={{
                required: 'Facility Name is required'
              }}
              render={({ field }) => <input className="input-in type_inp" type="text" name='abbreviation' placeholder='Facility Name' {...field} />}
            />
            {error?.errors?.abbreviation?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
            {errors?.abbreviation?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.abbreviation?.message} />
              </div>
            }
          </div>
        </div>

        <div className="row-primary row_secondary">
          <h2>Cell Phone *</h2>
          <div className="w-100">
            <Controller
              name="phone"
              control={control}
              rules={{
                required: 'Phone field is required'
              }}
              render={({ field }) => <PhoneInput className={`input-in type_inp ${error?.errors?.phone ? "border-red" : ""} `}
                type="tel" name='phone' placeholder='Phone number' required {...field} />}
            />
            {error?.errors?.phone?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
            {errors?.phone?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.phone?.message} />
              </div>
            }
          </div>
        </div>

        <div className="row-primary d-flex flex-column w-100 align-items-start">
          <h2 className='mt-1'>Address *</h2>
          <div className="w-100">
            <Controller
              name="address"
              rules={{
                required: 'Address required'
              }}
              control={control}
              render={({ field }) => <input className="input-in type_inp" type="text" name='address' placeholder='Address' {...field} />}
            />
            {error?.errors?.address?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
            {errors?.address?.message &&
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.address?.message} />
              </div>
            }
          </div>
        </div>
      </div>

      {statusPerm &&
        <div className="row-primary m-0 d-flex align-items-center justify-content-start row_secondary flex-row" >
      
          <h2 className='mt-0'>Status</h2>
          <Controller name="status" control={control} required
            rules={{
              required: true
            }}
            render={({ field }) => (
              <CustomSwitch labelText={field.value == 1 ? "Active" : "Inactive"} checked={field.value} handleChange={(checked) => field.onChange(checked ? 1 : 0)} />
            )}
          />
        </div>
      }



      <div className="Form-footer">
        <button type="button" className="Cancle_button" onClick={()=>setButtonLoader(false)} data-bs-dismiss="modal">Cancel</button>

        <SubmitButton
          loader={buttonLoader}
          btnText={item?.id ? "Update" : "Create"}
        />

      </div>
    </form>
  )
}

const AddFacility = ({ item, onClose, callback, show, statusPerm, userId }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Facility</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddFacilityForm item={item} userId={userId} handleClose={onClose} show={show} callback={callback} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddFacility
